<template>
    <transition name="slide_fade_modal_left">
        <div class="modal_left" v-show="stateModal">
            <div class="modal_left__content">
                <div class="modal_left__content_wrapper">
                    <div class="modal_left__container">
                        <div class="modal_left__header">
                            <div v-if="!isMobileScreen" class="modal_left__header_close cursor_pointer"
                                 @click.prevent="clickClose">
                                <svg height="24" width="24">
                                    <use xlink:href="/icons/base.svg#close"></use>
                                </svg>
                            </div>
                        </div>
                        <div class="modal_left__info">
                            <div class="modal_left__info_content">
                                <pre>{{ infoModal }}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
    <div v-if="isMobileScreen && stateModal" class="modal_shadow">
        <div class="modal_shadow__overlay">
        </div>
    </div>
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import {touchEvent} from "../../../mixins/touchEvent"

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "modal_left",
    mixins: [screenSize, touchEvent],
    components: {},
    data() {
        return {
            stateModal: false,
            infoModal: '',
        }
    },
    beforeMount() {
        EventBus.$on('show_modal_left', this.showModalLeft);
    },
    beforeUnmount() {
        EventBus.$off('show_modal_left', this.showModalLeft);
    },
    methods: {
        clickClose() {
            this.stateModal = false;
        },
        showModalLeft(content) {
            this.infoModal = content;
            this.stateModal = true;
        },
        moveTouchLeft() {
            this.clickClose();
        },
    },
}
</script>
